var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 50,
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 26.4645L38.6065 37.071L35.071 40.6065L30.5 36.0375V50H25.5V36.0325L20.9289 40.6065L17.3934 37.071L28 26.4645ZM28 0C36.9835 0 44.386 6.76902 45.3853 15.4849C51.2145 17.0788 55.5 22.414 55.5 28.75C55.5 35.922 50.009 41.8115 43.0015 42.444L43 37.5C43 29.2157 36.2842 22.5 28 22.5C19.904 22.5 13.3061 28.914 13.0103 36.9378L13 37.5L13.001 42.444C5.9924 41.813 0.5 35.923 0.5 28.75C0.5 22.414 4.7856 17.0788 10.6162 15.4853C11.614 6.76902 19.0165 0 28 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.ecf40162952e21e95d68d81846350088.svg";
export { ForwardRef as ReactComponent };